import Lottie from "react-lottie-player";
import React, { useState, useEffect } from "react";

// Importar animaciones
import rayoazul from "./assets/lottie/rayoazul.json";
import lineasblancasvolando from "./assets/lottie/lineasblancasvolando.json";
import efectoparticulas from "./assets/lottie/efectoparticulas.json";
import fuegoamarillo from "./assets/lottie/fuegoamarillo.json";
import neutron from "./assets/lottie/neutron.json";
import ondacircular from "./assets/lottie/ondacircular.json";

// Importar sonido de carga completada
//import efectocarga from "./assets/efectocarga.mp3"; // Asegúrate de tener el archivo en la carpeta 'assets/audio/'

export default function AwooEntrada() {
  const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);
  const [progress, setProgress] = useState(0);
  const [mostrarMensaje, setMostrarMensaje] = useState(false);

  // Seleccionar animación aleatoria
  useEffect(() => {
    const animacionesDisponibles = [
      lineasblancasvolando,
      efectoparticulas,
      fuegoamarillo,
      rayoazul,
      neutron,
      ondacircular,
    ];
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);

  // Simular barra de carga
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev < 100) return prev + 1;
        clearInterval(interval);
        return 100;
      });
    }, 30); // Carga más rápida (3 segundos)

    return () => clearInterval(interval);
  }, []);


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        background: "#000",
        color: "white",
        textAlign: "center",
        padding: "10px",
        position: "relative",
      }}
    >
      {/* Logo */}
      <div
        style={{
          position: "relative",
          width: "240px",
          display: "inline-block",
          marginBottom: "20px",
        }}
      >
        <img
          src={"images/awoo.png"}
          alt="Logo"
          style={{
            width: "100%",
            height: "240px",
            objectFit: "cover",
            borderRadius: "50%",
            boxShadow: "0px 0px 15px rgba(255, 255, 255, 0.3)",
          }}
        />

        {/* Animación de fondo */}
        <Lottie
          animationData={animacionSeleccionada}
          play
          loop
          style={{
            position: "absolute",
            width: "400px",
            height: "400px",
            top: "0",
            left: "0",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />
      </div>

      {/* Barra de carga */}
      <div
        style={{
          width: "80%",
          height: "10px",
          marginTop:"50px",
          backgroundColor: "#222",
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0px 0px 10px rgba(77, 249, 252, 0.5)",
          position: "relative",
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: "100%",
            backgroundColor: "#4df9fc",
            borderRadius: "10px",
            transition: "width 0.05s linear",
          }}
        />
      </div>

      {/* Texto del porcentaje con efecto de rebote */}
      <p
        style={{
          marginTop: "10px",
          fontSize: "16px",
          fontWeight: "bold",
          color: "#4df9fc",
          fontFamily: "Arial, sans-serif",
          transition: "transform 0.2s ease-out",
          transform: progress === 100 ? "scale(1.4)" : `scale(${1 + progress * 0.002})`, // Efecto de rebote
        }}
      >
        {progress}%
      </p>

      {/* Mensaje de bienvenida */}
      {mostrarMensaje && (
        <p
          style={{
            marginTop: "20px",
            fontSize: "28px",
            fontWeight: "bold",
            color: "#4df9fc",
            fontFamily: "Arial, sans-serif",
            opacity: 0,
            animation: "fadeIn 1s forwards",
          }}
        >
          ¡Bienvenido!
        </p>
      )}

      {/* Animación de bienvenida */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}
